import React, { useState } from "react";
import { Input } from "nav-frontend-skjema";
import { Hovedknapp } from "nav-frontend-knapper";
import { AlertStripeFeil } from "nav-frontend-alertstriper";

import { phoneService } from "../../api";
import { OutageNotice } from "./OutageNotice";

interface Props {
  onRequested: (phone: string) => void;
}

export const PhoneStep = ({ onRequested }: Props) => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(false);
    let requested = false;
    try {
      await phoneService.requestOtp(phone);
      requested = true;
    } catch {
      setError(true);
    } finally {
      setSubmitting(false);
    }
    if (requested) {
      onRequested(phone);
    }
  };

  return (
    <>
      <h1>Hent gavekortet ditt</h1>
      <OutageNotice />
      <p>
        Skriv inn telefonnummeret du oppga i undersøkelsen.
        <br />
        Vi sender deg en engangskode på SMS for å bekrefte at det er deg.
      </p>
      <form onSubmit={submit}>
        <Input
          id="phone"
          type="tel"
          label="Telefonnummer"
          placeholder="912 34 567"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
        {error && (
          <AlertStripeFeil role="alert">
            Noe gikk galt. Prøv igjen.
          </AlertStripeFeil>
        )}
        <Hovedknapp
          htmlType="submit"
          spinner={submitting}
          disabled={submitting || phone.length < 8}
        >
          Send kode
        </Hovedknapp>
      </form>
    </>
  );
};
